import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  setArticleTemplate,
  setArticleTemplateList,
  setArticleTemplateListTime,
  setArticleTemplateListProduct,
  setIsWaitingArticleTemplateGetResponse,
  setIsWaitingArticleTemplatePostResponse,
  setIsWaitingArticleTemplatePutResponse,
} from "../slices/articleTemplateSlice";
import { getApiUrl } from "../helpers/environmentHelper";
import { ArticleTemplate } from "../../models/responses/articleTemplate";
import { acquireApiToken } from "../helpers/apiTokenHelper";
import { on } from "events";

function toApiIntPrice(price: string | number): number {
  const num = typeof price === "string" ? parseFloat(price) : price;
  return Math.round(num * 100);
}

export const getArticleTemplates =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null
  ) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingArticleTemplateGetResponse(true));
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: ArticleTemplate[] = (
                  await axios.get(`${baseUrl}/article-templates`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setArticleTemplateList({ articleTemplates: getData }));
                dispatch(setIsWaitingArticleTemplateGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingArticleTemplateGetResponse(false));
        console.log(error);
      }
    };

export const getArticleTemplateById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      if (!id) return;
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingArticleTemplateGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: ArticleTemplate = (
                  await axios.get(`${baseUrl}/article-templates/${id}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setArticleTemplate({ articleTemplate: getData }));
                dispatch(setIsWaitingArticleTemplateGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingArticleTemplateGetResponse(false));
        console.log(error);
      }
    };

export const postArticleTemplate =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleTemplate: ArticleTemplate,
    onSuccess: (articleTemplateId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      dispatch(setIsWaitingArticleTemplatePostResponse(true));
      const baseUrl = getApiUrl(window.location.hostname, 2);
      let responseId: string | null = null;

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const apiArticleTemplate = {
                    ...articleTemplate,
                    salesPrice: toApiIntPrice(articleTemplate.salesPrice),
                  };
                  const responseData = await axios.post(
                    `${baseUrl}/article-templates`,
                    apiArticleTemplate,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );

                  if (responseData.status === 201) {
                    let locationArray =
                      responseData.headers["location"].split("/");
                    responseId = locationArray[locationArray.length - 1];
                  }
                }
              } finally {
                onSuccess(responseId);
                dispatch(setIsWaitingArticleTemplatePostResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };

export const putArticleTemplate =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleTemplate: ArticleTemplate,
    onSuccess: (articleTemplateId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingArticleTemplatePutResponse(true));      
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const apiArticleTemplate = {
                    ...articleTemplate,
                    salesPrice: toApiIntPrice(articleTemplate.salesPrice),
                  };
                  const responseData = await axios.put(
                    `${baseUrl}/article-templates`,
                    apiArticleTemplate,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );
                  if (responseData.status === 204) {
                    onSuccess(articleTemplate.id);
                  }
                }
              } finally {
                dispatch(setIsWaitingArticleTemplatePutResponse(false));
                onSuccess(articleTemplate.id);
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getArticleTemplatesByType = (
  instance: IPublicClientApplication,
  account: AccountInfo | null,
  articleType: number
) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleTemplateGetResponse(true));
    try {
      if (account) {
        acquireApiToken(instance, account)
          .then(async (response) => {
            if (response) {
              const getData: ArticleTemplate[] = (
                await axios.get(`${baseUrl}/article-templates/by-type/${articleType}`, {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                })
              ).data;
              if (articleType === 1) {
                dispatch(setArticleTemplateListTime({ articleTemplates: getData }));
              } else if (articleType === 0) {
                dispatch(setArticleTemplateListProduct({ articleTemplates: getData }));
              }
              dispatch(setIsWaitingArticleTemplateGetResponse(false));
            }
          });
      }
    } catch (error) {
      dispatch(setIsWaitingArticleTemplateGetResponse(false));
      console.log(error);
    }
  };
